import { render, staticRenderFns } from "./LKPublicationsCard.vue?vue&type=template&id=0e52a738&"
import script from "./LKPublicationsCard.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsCard.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
